import { normalizeName } from '@obraplan/core/domain/shared/naming';

/**
 * Chave de **busca** — acento não separa o que a pessoa procura.
 *
 * Deliberadamente diferente de `normalizeName`, que preserva acentos porque lá o assunto é
 * **identidade**: "Térreo" e "Terreo" são pavimentos diferentes, e fundi-los esconderia um
 * erro de digitação (RN-036). Procurar é outra coisa: quem digita "eletr" no campo de
 * busca quer a Elétrica, e receber "nenhuma frente" com a Elétrica na tela é a lista
 * dizendo que ela não existe.
 */
export function searchKey(value: string): string {
  return normalizeName(value)
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '');
}
